import { Fragment, useEffect, useState } from 'react';
import SourceButtonGroup from './SourceButtonGroup';

import {
  listSourceGDAs_DDAs,
  listSourceVariantAll_VDAs,
  listSourceAcademic,
  listSourceDiseaseAll,
  listSourceGeneALL,
} from '../../helpers/tableHelpers';
import { searchContext } from '../../../../../Context/Context.jsx';
import { SearchContext } from '../../../../../types';

const variantSourceButtons = ['VARIANTS', 'VDA'];
const diseasesSourceButtons = ['DISEASES', 'CHEMICALS'];
const genesSourceButtons = ['GENES'];
const gdaDDASourceButtons = ['GDA', 'DDA'];

export const getSourceList = ({ tab, restrictSources }) => {
  if (restrictSources === 'CURATED') return listSourceAcademic;
  if (variantSourceButtons.includes(tab)) return listSourceVariantAll_VDAs;
  if (diseasesSourceButtons.includes(tab)) return listSourceDiseaseAll;
  if (genesSourceButtons.includes(tab)) return listSourceGeneALL;
  if (gdaDDASourceButtons.includes(tab)) return listSourceGDAs_DDAs;
  return [];
};

export default function RenderSourcesLogic() {
  const { tab, restrictSources } = searchContext() as unknown as SearchContext;
  const [sourceList, setSourceList] = useState(getSourceList({ tab, restrictSources }));

  useEffect(() => {
    setSourceList(getSourceList({ tab, restrictSources }));
  }, [tab]);

  const renderButtonsByCategory = sourceListObj => {
    return Object.keys(sourceListObj).map(category => (
      <div key={category} className="my-3">
        <div className="text-blue font-semibold text-sm ml-2">{category}</div>
        <SourceButtonGroup sourceList={sourceListObj[category]} />
      </div>
    ));
  };

  return (
    <Fragment>
      {Array.isArray(sourceList) ? (
        <SourceButtonGroup sourceList={sourceList} />
      ) : (
        <div>{renderButtonsByCategory(sourceList)}</div>
      )}
    </Fragment>
  );
}
